// Ver panel-cliente/src/js/vistas/cambiar-contrasena.js para la
// explicación completa del diseño (cubre cambio voluntario y recuperación
// con la misma pantalla). Única diferencia real: un solo rol válido
// (super_admin) en vez de dos.

import { mostrarToast } from '@plataforma/ui';

import { navegarA } from '../enrutador.js';
import { actualizarContrasena, obtenerEstadoSesion } from '../estado-sesion.js';

import { montarShell } from './shell.js';

const LONGITUD_MINIMA = 8;

export function vistaCambiarContrasena(contenedorRaiz) {
  const { sesion, claims } = obtenerEstadoSesion();

  if (!sesion) {
    contenedorRaiz.innerHTML = `
      <div class="pf-login">
        <div class="pf-tarjeta pf-login__tarjeta" style="text-align:center;">
          <h1 class="pf-login__titulo">Enlace vencido</h1>
          <p class="pf-texto-suave">
            Este enlace para restablecer tu contraseña ya no es válido. Pide uno nuevo desde la pantalla de inicio de sesión.
          </p>
          <a href="#/login" class="pf-boton pf-boton--primario">Ir a inicio de sesión</a>
        </div>
      </div>
    `;
    return;
  }

  const dentroDelShell = claims.rol === 'super_admin';

  const contenido = dentroDelShell
    ? montarShell(contenedorRaiz, '')
    : (() => {
        contenedorRaiz.innerHTML = `<div class="pf-login"><div class="pf-tarjeta pf-login__tarjeta" id="pf-cc-tarjeta"></div></div>`;
        return contenedorRaiz.querySelector('#pf-cc-tarjeta');
      })();

  contenido.innerHTML = `
    <h1 class="${dentroDelShell ? '' : 'pf-login__titulo'}">Cambiar contraseña</h1>
    <p class="pf-texto-suave" style="margin: 4px 0 16px;">
      Elige una nueva contraseña de al menos ${LONGITUD_MINIMA} caracteres.
    </p>
    <form id="pf-form-cambiar-contrasena" novalidate>
      <div class="pf-campo">
        <label for="pf-cc-nueva">Nueva contraseña</label>
        <input type="password" id="pf-cc-nueva" autocomplete="new-password" required minlength="${LONGITUD_MINIMA}" />
      </div>
      <div class="pf-campo">
        <label for="pf-cc-confirmar">Confirmar contraseña</label>
        <input type="password" id="pf-cc-confirmar" autocomplete="new-password" required minlength="${LONGITUD_MINIMA}" />
      </div>
      <p class="pf-campo__error" id="pf-cc-error" hidden></p>
      <div class="pf-fila" style="justify-content: flex-end;">
        <button type="submit" class="pf-boton pf-boton--primario" id="pf-cc-submit">Guardar</button>
      </div>
    </form>
  `;

  const form = contenido.querySelector('#pf-form-cambiar-contrasena');
  const errorEl = contenido.querySelector('#pf-cc-error');
  const submitEl = contenido.querySelector('#pf-cc-submit');

  form.addEventListener('submit', async (evento) => {
    evento.preventDefault();
    errorEl.hidden = true;

    const nueva = contenido.querySelector('#pf-cc-nueva').value;
    const confirmar = contenido.querySelector('#pf-cc-confirmar').value;

    if (nueva.length < LONGITUD_MINIMA) {
      errorEl.textContent = `La contraseña debe tener al menos ${LONGITUD_MINIMA} caracteres.`;
      errorEl.hidden = false;
      return;
    }
    if (nueva !== confirmar) {
      errorEl.textContent = 'Las contraseñas no coinciden.';
      errorEl.hidden = false;
      return;
    }

    submitEl.disabled = true;
    submitEl.textContent = 'Guardando…';

    const { error } = await actualizarContrasena(nueva);

    submitEl.disabled = false;
    submitEl.textContent = 'Guardar';

    if (error) {
      errorEl.textContent = 'No se pudo actualizar la contraseña. Intenta de nuevo.';
      errorEl.hidden = false;
      return;
    }

    mostrarToast('Contraseña actualizada.', { tono: 'exito' });
    navegarA('/');
  });
}
